import { render, staticRenderFns } from "./BarChartLegendItem.vue?vue&type=template&id=56d6f082&scoped=true"
import script from "./BarChartLegendItem.vue?vue&type=script&lang=js"
export * from "./BarChartLegendItem.vue?vue&type=script&lang=js"
import style0 from "./BarChartLegendItem.vue?vue&type=style&index=0&id=56d6f082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d6f082",
  null
  
)

export default component.exports